var Answer = Chaplin.Model.extend({
});

_.extend(EF.Models.Assessments, {
  Answer: Answer
});
